import { Configuration, LogLevel, PopupRequest } from "@azure/msal-browser";

/**
 * MSAL Configuration for multi-tenant Microsoft Entra ID authentication
 *
 * Using "organizations" endpoint to allow any work/school account from any tenant
 * Partners will see a consent prompt on first login - no manual app registration needed
 */

const clientId = import.meta.env.VITE_MICROSOFT_CLIENT_ID || "";

export const msalConfig: Configuration = {
  auth: {
    clientId: clientId,
    // Multi-tenant: allows any Azure AD organization
    authority: "https://login.microsoftonline.com/organizations",
    // Where to redirect after login (for popup, this is where the popup redirects to)
    redirectUri: window.location.origin,
    // Where to redirect after logout
    postLogoutRedirectUri: window.location.origin,
    // Set to false for popup flow - popup should close, not navigate
    navigateToLoginRequestUrl: false,
  },
  cache: {
    // Use sessionStorage for better security (cleared when browser closes)
    cacheLocation: "sessionStorage",
    // Recommended for avoiding issues with IE11/Edge
    storeAuthStateInCookie: false,
  },
  system: {
    // Allow popup to properly close and communicate with parent window
    allowNativeBroker: false,
    // Increase timeout for slow connections and post-logout scenarios
    windowHashTimeout: 120000, // 120 seconds (increased for post-logout reliability)
    iframeHashTimeout: 20000, // 20 seconds
    loadFrameTimeout: 20000, // 20 seconds
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
        }
      },
      // Set to LogLevel.Verbose for debugging
      logLevel: LogLevel.Warning,
    },
  },
};

/**
 * Scopes for ID token and access token
 * User.Read is required to get basic profile info
 */
export const loginRequest: PopupRequest = {
  scopes: ["openid", "profile", "email", "User.Read"],
};

/**
 * Add additional scopes here if your app needs more permissions
 */
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};
